/* SAGÓ · chip de ahorro en la tarjeta de una caja (Silvia, 29/10/2026).
   La tarjeta (snippets/sago-card-product.liquid) deja un <sago-ahorro-chip data-url="…"> vacío en las cajas; aquí se
   pide sections/sago-ahorro-caja.liquid para ese producto y se pone el chip que devuelve. Si no hay chip (falta un
   plato, no hay ahorro o falla la petición), la tarjeta se queda como estaba. */
if (!customElements.get('sago-ahorro-chip')) {
  customElements.define(
    'sago-ahorro-chip',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.pedido || !this.dataset.url) return;
        this.dataset.pedido = '1';
        const url = this.dataset.url.split('?')[0] + '?section_id=sago-ahorro-caja';
        fetch(url)
          .then((r) => (r.ok ? r.text() : ''))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const chip = doc.querySelector('.sago-ahorro-chip');
            if (!chip) return;
            const hoja = doc.querySelector('link[rel="stylesheet"]');
            if (hoja && !document.querySelector(`link[href="${hoja.getAttribute('href')}"]`)) {
              document.head.appendChild(hoja);
            }
            this.replaceChildren(chip);
          })
          .catch(() => {});
      }
    }
  );
}
